import { UseGuardStepHook } from "../useGuardStep";
import { useFlowState } from "@/hooks/useFlowState";
import { useCurrentWorkspace, useWorkspacesInitializing } from "@/store";
import { useLocation, useSearchParams } from "react-router-dom";

export const useGuardNoWorkspace: UseGuardStepHook = () => {
    const currentWorkspace = useCurrentWorkspace();
    const workspacesInitializing = useWorkspacesInitializing();
    const { step, computeUrlPath } = useFlowState();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    if (workspacesInitializing) {
        return { loading: true, passThrough: true, errors: [], redirect: null };
    }

    const intendedPath = currentWorkspace?.url ? `/${currentWorkspace.url}` : "/";
    const shouldRedirect = !location.pathname.startsWith(intendedPath);
    const hasModalOpen = searchParams.get("open") !== null;

    if (hasModalOpen) {
        return { loading: false, step, passThrough: true, errors: [], redirect: null };
    }

    const redirectPath = shouldRedirect
        ? computeUrlPath({ workspaceUrl: currentWorkspace?.url }) + location.search
        : null;

    return {
        loading: false,
        step,
        passThrough: !shouldRedirect,
        errors: [],
        redirect: redirectPath
    };
};
